<!-- components/SvgIcon.vue -->
<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="svg-icon"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path v-for="item, index in paths" :d="item" :key="index"/>
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: false
    },
    paths: {
      type: Array,
      required: true
    },
    fill: {
      type: String,
      default: 'none'
    }
  },
}
</script>

<style scoped>
.svg-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
</style>